import type {PropsWithChildren} from 'react';

import {Link} from '@/modules/foundation/components/link';
import {cn} from '@/modules/foundation/shared/tailwind';

type Props = PropsWithChildren & {
	href?: string;
	targetBlank?: boolean;
	className?: string;
};

export const PortableLink = ({
	children,
	href,
	targetBlank,
	className,
}: Props) => {
	return (
		<Link
			href={href}
			targetBlank={targetBlank}
			className={cn(
				'text-primary-15',
				'underline',
				'underline-offset-4',
				'hover:no-underline',
				className,
			)}
		>
			{children}
		</Link>
	);
};
